import React from "react";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import { bootstrapI18n } from "./i18n/config";

// DEV ONLY: Prevent stale service worker / cache from mixing Vite prebundled deps
// (which can lead to React hooks crashing with "Cannot read properties of null (reading 'useEffect')").
if (import.meta.env.DEV && "serviceWorker" in navigator) {
  const swResetKey = "ck:dev:sw_reset_once";
  const alreadyAttempted = sessionStorage.getItem(swResetKey) === "1";
  if (!alreadyAttempted) sessionStorage.setItem(swResetKey, "1");

  navigator.serviceWorker
    .getRegistrations()
    .then(async (regs) => {
      if (!regs.length) return;

      // If we've already attempted once this session, don't force another reload.
      const shouldReload = !alreadyAttempted;

      await Promise.all(regs.map((r) => r.unregister()));

      if ("caches" in window) {
        const keys = await caches.keys();
        await Promise.all(keys.map((k) => caches.delete(k)));
      }

      // Reload once after cleanup so all modules come from the same build.
      // Guard against loops by reloading only on the first attempt.
      if (shouldReload) window.location.reload();
    })
    .catch(() => {
      // Ignore cleanup failures in dev.
    });
}

bootstrapI18n().then(() => {
  createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </React.StrictMode>
  );
});
